import { useContext, useEffect, useState, useMemo } from "react";
import { AppContext } from "../context/AppContext";
import { Box, Paper, Snackbar, Typography } from "@mui/material";
import { ClubLocation } from "../components/ClubLocation";
import { ClubMap } from "../components/ClubMap";
import { MemberPasses } from "../components/MemberPasses";
import { getOrder } from "../services/firebase";
import { centsToCurrency } from "../services/firebase";
const ThankYouPage = () => {
  const {
    order: { orderId },
  } = useContext(AppContext);
  const [currentOrder, setCurrentOrder] = useState(null);
  useEffect(() => {
    getOrder(orderId).then((oc) => {
      setCurrentOrder(oc);
    });
  }, [orderId]);

  const currentOrderIncludesPasses = useMemo(() => {
    if (!currentOrder) {
      return false;
    }
    return (
      currentOrder.lineItems.filter((li) => li.productType === "pass").length >
      0
    );
  }, [currentOrder]);

  const currentOrderIncludesTickets = useMemo(() => {
    if (!currentOrder) {
      return false;
    }
    return (
      currentOrder.lineItems.filter((li) => li.productType === "ticket")
        .length > 0
    );
  }, [currentOrder]);

  if (!currentOrder) {
    return <div>Loading...</div>;
  }

  return (
    <Paper sx={{ px: 8, py: 8 }}>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={currentOrderIncludesPasses}
        autoHideDuration={6000}
        message="Your passes are being generated..."
      />
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={currentOrderIncludesTickets}
        autoHideDuration={6000}
        message="Your tickets are being generated..."
      />
      <Typography variant="h5" gutterBottom>
        Thank you for your purchase!
      </Typography>
      <Typography variant="subtitle1" gutterBottom noWrap>
        <strong>Order ID:</strong> {orderId}
      </Typography>
      <Typography variant="subtitle1" gutterBottom noWrap>
        <strong>Date:</strong>{" "}
        {currentOrder.createdate.toDate().toLocaleDateString()} at{" "}
        {currentOrder.createdate.toDate().toLocaleTimeString()}
      </Typography>
      <Typography variant="h6" gutterBottom>
        Order Summary
      </Typography>
      <Box sx={{ mb: 2, p: 2, boxShadow: 1 }}>
        {currentOrder.lineItems.map((lineItem) => (
          <Box
            key={lineItem.id}
            sx={{ display: "flex", justifyContent: "space-between" }}
          >
            <Typography variant="subtitle1" gutterBottom>
              {lineItem.name}
            </Typography>
            <Typography variant="subtitle2" gutterBottom>
              {lineItem.quantity} x {lineItem.price}
            </Typography>
            <Typography variant="subtitle2" gutterBottom>
              {centsToCurrency(lineItem.quantity * lineItem.amount)}
            </Typography>
          </Box>
        ))}
        {currentOrder.discount && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              mt: 2,
              fontWeight: "bold",
            }}
          >
            <Typography variant="subtitle1" gutterBottom>
              Discount
            </Typography>
            <Typography variant="subtitle2" gutterBottom>
              -{centsToCurrency(currentOrder.discount.amountOff)}
            </Typography>
          </Box>
        )}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            my: 2,
            fontWeight: "bold",
          }}
        >
          <Typography variant="subtitle1" gutterBottom>
            Total
          </Typography>
          <Typography variant="subtitle2" gutterBottom>
            {centsToCurrency(currentOrder.amount)}
          </Typography>
        </Box>
        <Typography variant="body2">
          A receipt has been emailed to you.
        </Typography>
      </Box>

      <Paper
        sx={{
          maxHeight: "40vh",
          overflow: "auto",
          mb: 4,
          p: 2,
          boxShadow: 1,
        }}
      >
        <MemberPasses />
      </Paper>
      <Paper sx={{ mb: 4, p: 2, boxShadow: 1 }}>
        <ClubLocation />
        <ClubMap />
      </Paper>
    </Paper>
  );
};

export default ThankYouPage;
